export default __webpack_public_path__ + "static/media/governance.78034938.svg";